import { Badge, TextField } from "@/components/kit";
import { Typography } from "@/components/kit";
import { Accordion } from "@/components/kit";
import { useState } from "react";
import classNames from "classnames";
import { Field, FieldProps } from "formik";

const GeneralAminInfo = () => {
  const [isOpenAdminInformation, setIsOpenAdminInformation] = useState<
    number | undefined
  >(0);
  return (
    <Accordion
      isOpen={isOpenAdminInformation === 0}
      onChange={() => {
        setIsOpenAdminInformation((p) => (p === 0 ? undefined : 0));
      }}
      title={
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <Typography variant="Title5-Regular">
              📋 Admin information
            </Typography>
            <Badge size="sm" state="danger">
              Required
            </Badge>
          </div>

          {isOpenAdminInformation === 0 && (
            <Typography color="text-gray-300" variant="Body3-Regular">
              Please fill out your personal and company details below. This
              information helps us personalize your experience and ensure
              accurate communication.
            </Typography>
          )}
        </div>
      }
      descriptionClassName={classNames("!mt-0 !px-6", {
        "!py-0": isOpenAdminInformation !== 0,
        "!pb-4": isOpenAdminInformation === 0,
      })}
      headerClassName={classNames("!px-6 !py-5")}
    >
      <div className="flex flex-col gap-5">
        <div className="flex items-c gap-2">
          <Field name="firstName">
            {({ field, meta: { error, touched } }: FieldProps) => (
              <TextField
                {...field}
                error={touched && error}
                label="First name*"
              />
            )}
          </Field>
          <Field name="lastName">
            {({ field, meta: { error, touched } }: FieldProps) => (
              <TextField
                {...field}
                error={touched && error}
                label="Last name*"
              />
            )}
          </Field>
        </div>
        <div className="w-full gap-2 flex flex-col">
          <Field name="displayName">
            {({ field, meta: { error, touched } }: FieldProps) => (
              <TextField
                {...field}
                error={touched && error}
                label="Display name*"
              />
            )}
          </Field>
          <Typography
            variant="Caption1-Regular"
            className="!text-gray-500 ps-4"
          >
            How do you want your name to be displayed?
          </Typography>
        </div>
        <div className="w-full gap-2 flex flex-col">
          <Field name="email">
            {({ field, meta: { error, touched } }: FieldProps) => (
              <TextField
                {...field}
                error={touched && error}
                label="Company email*"
                type="email"
              />
            )}
          </Field>
          <Typography
            variant="Caption1-Regular"
            className="!text-gray-500 ps-4"
          >
            Provide the email given to you by your company{" "}
          </Typography>
        </div>
        <div className="w-full gap-2 flex flex-col">
          <Field name="personalEmail">
            {({ field, meta: { error, touched } }: FieldProps) => (
              <TextField
                {...field}
                error={touched && error}
                label="Alternative email"
                type="email"
              />
            )}
          </Field>
        </div>
      </div>
    </Accordion>
  );
};

export default GeneralAminInfo;
